export function timestampToLocalStringISOFormat(timestamp: Date) {
	const time = timestamp.toLocaleTimeString("en-GB", { hour12: false });
	const fullDate = timestamp.toLocaleDateString("en-GB");
	return `${fullDate.slice(6)}-${fullDate.slice(3, 5)}-${fullDate.slice(0, 2)}T${time}`;
  }
  